import AutoLayout from "../../Layouts/AutoLayout/AutoLayout";
import Icon from "../../Icon/Icon";
import React from "react";
import RippleEffect from "../../RippleEffect/RippleEffect";
import styled from "styled-components";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "../../Layouts/AutoLayout/AutoLayoutEnums";
import { ITheme } from "../../Themes/ThemeTypes";
import { RippleEffectShapeEnum } from "../../RippleEffect/RippleEffectShapeEnum";
import { ThemeColorEnum, ThemeIconEnum, ThemeIconSizeEnum } from "../../Themes/ThemeEnums";
import { IconButtonSizeEnum } from "./IconButtonEnums";

const SIZE_TOKENS: Record<IconButtonSizeEnum, { visual: number; icon: ThemeIconSizeEnum }> = {
  [IconButtonSizeEnum.EXTRA_SMALL]: { visual: 32, icon: ThemeIconSizeEnum.EXTRA_SMALL },
  [IconButtonSizeEnum.SMALL]: { visual: 40, icon: ThemeIconSizeEnum.SMALL },
};
export const TOUCH_TARGET = 48;

const IconAutoLayout = styled(AutoLayout)<{ theme: ITheme; $isDisabled?: boolean }>`
  border-radius: 100%;
  cursor: ${(props) => (props.$isDisabled ? "auto" : "pointer")};
  overflow: hidden;
  outline: none;
  opacity: ${(props) => (props.$isDisabled ? props.theme.base.opacity.disabled_container : 1)};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:hover {
    background-color: ${(props) => props.theme.colors.on_surface_variant_opacity_0_08};
  }
`;

interface IconButtonProps {
  icon: ThemeIconEnum;
  isDisabled?: boolean;
  onClick?: () => void;
  size?: IconButtonSizeEnum;
  ariaLabel?: string;
}

const IconButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${TOUCH_TARGET}px;
  height: ${TOUCH_TARGET}px;
`;

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  isDisabled,
  size = IconButtonSizeEnum.SMALL,
  ariaLabel,
}) => {
  const { visual, icon: iconSize } = SIZE_TOKENS[size];
  return (
    <IconButtonWrapper>
      <RippleEffect shape={RippleEffectShapeEnum.CIRCLE}>
        <IconAutoLayout
          $width={visual}
          $height={visual}
          $horizontalResizing={AutoLayoutResizingEnum.FIXED}
          $verticalResizing={AutoLayoutResizingEnum.FIXED}
          $align={AutoLayoutAlignEnum.CENTER}
          $direction={AutoLayoutDirectionEnum.HORIZONTAL}
          $isDisabled={isDisabled}
          onClick={
            isDisabled
              ? () => {
                  /* disabled */
                }
              : onClick
          }
          role="button"
          tabIndex={isDisabled ? -1 : 0}
          aria-label={ariaLabel}
          title={ariaLabel}
          aria-disabled={isDisabled}
        >
          <Icon icon={icon} color={ThemeColorEnum.ON_SURFACE_VARIANT} size={iconSize} />
        </IconAutoLayout>
      </RippleEffect>
    </IconButtonWrapper>
  );
};

export default IconButton;
